import { BaseModel } from './base.model'
import { LessonQuiz } from './lesson-quiz.model'
import { LessonText } from './lesson-text.model'
import { Video } from './video.model'
import { Interactive } from './interactive.model'


export class LessonSection extends BaseModel<LessonSection> {
  static DEFAULT_ATTRIBUTES = {}

  _destroy: boolean
  content: LessonQuiz|LessonText|Video|Interactive
  contentId: number
  id: number
  position: number
  type: string
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/lesson-section.model.ts